import React, { useRef, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { useHistory, useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';
import { BrCalendar } from './BrCalendar';

import api from '../api/api';

import '../layout/sass/_form.scss';
import { FormBoletimItens } from './FormBoletimItens';
import { TabelaBoletimItens } from './TabelaBoletimItens';

export const FormBoletim = ({ isEditing, isLoading }) => {

    const history = useHistory();
    const { id } = useParams();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [produtores, setProdutores] = useState(null);
    const [propriedades, setPropriedades] = useState(null);
    const [tecnicos, setTecnicos] = useState(null);
    const [boletinsItens, setBoletinsItens] = useState([]);
    const [showFormBoletins, setShowFormBoletins] = useState(false);

    const [produtos, setProdutos] = useState([]);

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);


    const schema = Yup.object().shape({
        dataVisita: Yup
            .date()
            .typeError("Uma data da visita deve ser inserida")
            .required("A Data da visita é obrigatória"),
        dataEmissao: Yup
            .date()
            .typeError("Uma data emissão deve ser inserida")
            .required("A data emissão é obrigatória"),
        produtorId: Yup
            .number()
            .required("O produtor é obrigatório")
            .positive("O produtor deve ser selecionado")
            .integer("O produtor deve estar na lista"),
        propriedadeId: Yup
            .number()
            .required("A propriedade é obrigatório")
            .positive("A propriedade deve ser selecionado")
            .integer("O produtor deve estar na lista"),
        tecnicoId: Yup
            .number()
            .required("O técnico é obrigatório")
            .positive("O técnico deve ser selecionado")
            .integer("O técnico deve estar na lista")

    })



    const formik = useFormik({
        initialValues: {
            "id": 0,
            "dataVisita": "",
            "dataEmissao": "",
            "produtorId": 0,
            "produtorNome": "",
            "propriedadeId": 0,
            "propriedadeNome": "",
            "tecnicoId": 0,
            "tecnicoNome": "",
            "itens": [],
        },


        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true)


            data.itens = boletinsItens;


            await api.post("boletim", data)

            try {

                if (!isEditing) {

                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.produtorNome} adicionado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/boletim')

                    }, 2000)

                }
                else {

                    await api.put("boletim", data)

                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.produtorNome} atualizado(a) com sucesso` });
                    setTimeout(() => {

                        history.push('/boletim')

                    }, 2000)
                }

            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar boletim!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar boletim!', detail: error.toString() });

            }

            setIsSubmiting(false)
        }
    })



    useEffect(() => {

        if (isEditing) {
            api.get(`boletim/${id}`).then((response) => {

                formik.setValues(response.data);

                const tempProdutoItens = response.data.itens.map((i) => { return { id: i.id, produtoNome: i.produtoNome, produtoEmbalagem: i.produtoEmbalagem } })

                setProdutos(tempProdutoItens);

                const itens = response.data.itens.map((i) => {
                    return {
                        itensId: i.id,
                        produtoId: i.produtoId,
                        produtoNome: i.produtoNome,
                        areaProducao: i.areaProducao,
                        producaoEstimada: i.producaoEstimada,
                        producaoEmbalada: i.producaoEmbalada,
                        produtoEmbalagem: i.produtoEmbalagem,
                        inicioColheita: i.inicioColheita,
                        fimColheita: i.fimColheita
                    }
                });

                setBoletinsItens(itens);


            });

            handleGetProdutor();

            handleGetTecnico();

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleGetProdutor() {

        api.get("pessoa/tipo/1").then((response) => {

            const produtoresTemp = response.data.map((i) => {
                return {
                    id: i.id,
                    nome: i.nome + " - " + i.cpfcnpj
                }
            });

            setProdutores(produtoresTemp)
        });

    }

    function handleGetTecnico() {
        api.get("pessoa/tipo/2").then((response) => {

            const tecnicoTemp = response.data.map((i) => {
                return {
                    id: i.id,
                    nome: i.nome + " - " + i.cpfcnpj
                }
            });

            setTecnicos(tecnicoTemp)
        });
    }

    function handleGetPropriedade() {
        api.get(`propriedade/proprietario/${formik.values.produtorId}`).then((response) => {
            setPropriedades(response.data);
        })
    }


    useEffect(() => {
        if (formik.values.produtorId !== "") {
            api.get(`propriedade/proprietario/${formik.values.produtorId}`).then((response) => {
                setPropriedades(response.data);
            })
        }
    }, [formik.values.produtorId])


    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Boletim</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">

                        <div className="p-field p-col-12 p-sm-4 p-md-2">
                            <label
                                htmlFor="dataVisita"
                                className={classNames({ 'p-error': isFormFieldValid('dataVisita') })}
                            >
                                Data Visita
                            </label>
                            {
                                !isLoading ?
                                    <BrCalendar
                                        id="dataVisita"
                                        name="dataVisita"
                                        disabledDays={[]}
                                        value={new Date(formik.values.dataVisita).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
                                        onChange={formik.handleChange}
                                        placeholder={isEditing === true ? new Date(formik.values.dataVisita).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : ""}
                                        readonly={true}
                                        className={classNames({ 'p-invalid': isFormFieldValid('dataVisita') })}
                                        yearRange={`2000:${new Date().getFullYear()}`}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }

                            {formik.errors.dataVisita && formik.touched.dataVisita &&
                                <ErrorValidationMessage message={formik.errors.dataVisita} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4 p-md-2">
                            <label
                                htmlFor="dataEmissao"
                                className={classNames({ 'p-error': isFormFieldValid('dataEmissao') })}
                            >
                                Data Emissão
                            </label>
                            {
                                !isLoading ?
                                    <BrCalendar
                                        id="dataEmissao"
                                        name="dataEmissao"
                                        disabledDays={[]}
                                        value={new Date(formik.values.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
                                        onChange={formik.handleChange}
                                        placeholder={isEditing === true ? new Date(formik.values.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : ""}
                                        readonly={true}
                                        className={classNames({ 'p-invalid': isFormFieldValid('dataEmissao') })}
                                        yearRange={`2000:${new Date().getFullYear() + 1}}`}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }

                            {formik.errors.dataEmissao && formik.touched.dataEmissao &&
                                <ErrorValidationMessage message={formik.errors.dataEmissao} />
                            }
                        </div>




                        <div className="p-field p-col-12 p-sm-3">
                            <label
                                htmlFor="produtor"
                                className={classNames({ 'p-error': isFormFieldValid('produtor') })}
                            >
                                Produtor
                            </label>
                            {
                                !isLoading ?
                                    <Dropdown
                                        id="produtorId"
                                        name="produtorId"
                                        options={produtores}
                                        filter={true}
                                        emptyMessage={"Nenhuma produtor encontrado"}
                                        optionLabel="nome"
                                        optionValue="id"
                                        placeholder="Selecione um produtor"
                                        className={classNames({ 'p-invalid': isFormFieldValid('produtorId') })}
                                        value={formik.values.produtorId}
                                        onChange={option => formik.setFieldValue("produtorId", option.value)}
                                        emptyFilterMessage={"Nenhuma produtor encontrado"}
                                        disabled={produtores === ''}
                                        onFocus={handleGetProdutor}

                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.produtorId && formik.touched.produtorId &&
                                <ErrorValidationMessage message={formik.errors.produtorId} />
                            }
                        </div>



                        <div className="p-field p-col-12 p-sm-3">
                            <label
                                htmlFor="propriedade"
                                className={classNames({ 'p-error': isFormFieldValid('propriedade') })}
                            >
                                Propriedade
                            </label>
                            {
                                !isLoading ?
                                    <>
                                        <Dropdown
                                            id="propriedadeId"
                                            name="propriedadeId"
                                            options={propriedades}
                                            filter={true}
                                            emptyMessage={"Nenhuma propriedade encontrada"}
                                            optionLabel="nome"
                                            optionValue="id"
                                            placeholder="Selecione uma propriedade"
                                            className={classNames({ 'p-invalid': isFormFieldValid('propriedadeId') })}
                                            value={formik.values.propriedadeId}
                                            onChange={option => formik.setFieldValue("propriedadeId", option.value)}
                                            emptyFilterMessage={"Nenhuma propriedade encontrada"}
                                            disabled={propriedades === ''}
                                            onFocus={handleGetPropriedade}
                                        />


                                    </>
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.propriedadeId && formik.touched.propriedadeId &&
                                <ErrorValidationMessage message={formik.errors.propriedadeId} />
                            }
                        </div>



                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="tecnico"
                                className={classNames({ 'p-error': isFormFieldValid('tecnico') })}
                            >
                                Técnico
                            </label>
                            {
                                !isLoading ?
                                    <Dropdown
                                        id="tecnicoId"
                                        name="tecnicoId"
                                        options={tecnicos}
                                        filter={true}
                                        emptyMessage={"Nenhuma técnico encontrado"}
                                        optionLabel="nome"
                                        optionValue="id"
                                        placeholder="Selecione um técnico"
                                        className={classNames({ 'p-invalid': isFormFieldValid('tecnicoId') })}
                                        value={formik.values.tecnicoId}
                                        onChange={option => formik.setFieldValue("tecnicoId", option.value)}
                                        emptyFilterMessage={"Nenhum técnico encontrado"}
                                        disabled={tecnicos === ''}
                                        onFocus={handleGetTecnico}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.tecnicoId && formik.touched.tecnicoId &&
                                <ErrorValidationMessage message={formik.errors.tecnicoId} />
                            }
                        </div>



                    </div>

                    <FormBoletimItens
                        visible={showFormBoletins}
                        setVisible={setShowFormBoletins}
                        boletimItens={boletinsItens}
                        setBoletimItens={setBoletinsItens}
                        produtos={produtos}
                    />

                    <br />

                    <div className="p-d-flex p-jc-end p-mr-1" id="BoletimItens" >

                        <TabelaBoletimItens boletimItens={boletinsItens} setBoletimItens={setBoletinsItens} />

                    </div>



                    <div className="p-formgrid p-grid p-fluid p-mx-5">
                        {
                            !isLoading ?
                                <Button
                                    label={isEditing ? 'Atualizar' : 'Salvar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                />
                                :
                                <></>

                        }
                        <br />
                    </div>

                </form>
            </div>
        </div>

    );
}
